import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppDownloadComponent } from './components/common/app-download/app-download.component';
import { FeedbackComponent } from './components/common/feedback/feedback.component';
import { VideoComponent } from './components/common/video/video.component';
import { ProcessComponent } from './components/common/process/process.component';
import { PartnerComponent } from './components/common/partner/partner.component';
import { InstagramComponent } from './components/common/instagram/instagram.component';
import { FunfactsComponent } from './components/common/funfacts/funfacts.component';
import { ToastrModule } from 'ngx-toastr';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from "@angular/material/table";
import { InsertOTPDialogComponent } from './appviews/tools/insert-otpdialog/insert-otpdialog.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { DatePipe, DecimalPipe } from '@angular/common';
import { AboutComponent } from './appviews/pages/about/about.component';
import { ContactComponent } from './appviews/pages/contact/contact.component';
import { FaqComponent } from './appviews/pages/faq/faq.component';
import { ErrorComponent } from './appviews/pages/error/error.component';
import { HomeComponent } from './appviews/pages/home/home.component';
import { PrivacyComponent } from './appviews/pages/privacy/privacy.component';
import { TermsComponent } from './appviews/pages/terms/terms.component';
import { CartComponent } from './appviews/shop/cart/cart.component';
import { CheckoutComponent } from './appviews/shop/checkout/checkout.component';
import { TrackingDetailsComponent } from './appviews/shop/tracking-details/tracking-details.component';
import { TrackingComponent } from './appviews/shop/tracking/tracking.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxPaginationModule } from 'ngx-pagination';
import { ShopComponent } from './appviews/shop/shop/shop.component';
import { ProductDetailsComponent } from './appviews/shop/product-details/product-details.component';
import { FooterComponent } from './common/footer/footer.component';
import { HeaderComponent } from './common/header/header.component';
import { FacilityStyleComponent } from './common/facility-style/facility-style.component';
import { OccasionCategoriesComponent } from './common/occasion-categories/occasion-categories.component';
import { AppLoaderComponent } from './common/service/app-loader/app-loader.component';
import { AppComfirmComponent } from './common/service/app-confirm/app-confirm.component';
import { AppConfirmService } from './common/service/app-confirm/app-confirm.service';
import { AppLoaderService } from './common/service/app-loader/app-loader.service';
import { HomeBannerComponent } from './appviews/pages/home/home-banner/home-banner.component';
import { PaymentResultComponent } from './appviews/shop/payment-result/payment-result.component';
import { MostSalesComponent } from './common/most-sales/most-sales.component';
import { LatestProductComponent } from './common/latest-product/latest-product.component';
import { OfferComponent } from './common/offer/offer.component';
import { FeatureComponent } from './common/feature/feature.component';
import { HeaderTwoComponent } from './common/header-two/header-two.component';
import { NavbarComponent } from './common/navbar/navbar.component';
import { SubcategoryComponent } from './appviews/shop/subcategory/subcategory.component';
import { CategoryComponent } from './common/category/category.component';
import { FeaturesComponent } from './components/common/features/features.component';
import { OfferShopComponent } from './appviews/shop/offer-shop/offer-shop.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { OccasionShopComponent } from './appviews/shop/occasion-shop/occasion-shop.component';
import { ItemsComponent } from './common/items/items.component';
//import { MdSidenavModule } from '@angular/material'


export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        AppDownloadComponent,
        AppLoaderComponent,
        AppComfirmComponent,
        FeedbackComponent,
        VideoComponent,
        ProcessComponent,
        PartnerComponent,
        InstagramComponent,
        AboutComponent,
        FunfactsComponent,
        ContactComponent,
        PrivacyComponent,
        TermsComponent,
        CartComponent,
        CheckoutComponent,
        TrackingComponent,
        TrackingDetailsComponent,
        FaqComponent,
        ErrorComponent,
        InsertOTPDialogComponent,
        HomeComponent,
        ShopComponent,
        ProductDetailsComponent,
        HeaderComponent,
        HeaderTwoComponent,
        FacilityStyleComponent,
        OccasionCategoriesComponent,
        HomeBannerComponent,
        PaymentResultComponent,
        MostSalesComponent,
        LatestProductComponent,
        OfferComponent,
        FeatureComponent,
        NavbarComponent,
        SubcategoryComponent,
        CategoryComponent,
        FeaturesComponent,
        OfferShopComponent,
        OccasionShopComponent,
        ItemsComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule, NoopAnimationsModule,
        NgxTypedJsModule,
        FormsModule,
        CarouselModule,
        SlickCarouselModule,
        NgxPaginationModule,
        HttpClientModule,
        Ng2TelInputModule,
        NgOtpInputModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        MatDialogModule,
        ToastrModule.forRoot(),
        MatProgressSpinnerModule,
        MatTableModule
    ],
    providers: [AppConfirmService,
        AppLoaderService, DatePipe, DecimalPipe],
    bootstrap: [AppComponent]
})
export class AppModule { }
